module.exports = __webpack_public_path__ + "static/media/猫咪.78d20688.svg";